const $ = require('jquery');

if (!window.vf) {
    window.vf = {};
}

require('./services');

require('./layout/header/header.js');
require('./layout/footer/footer.js');
require('./main.scss');
require('lite-youtube-embed');
require('lite-youtube-embed/src/lite-yt-embed.css');
require('../src/brochure-popup/brochure-popup.js');

window.jQuery = window.$ = $;